import React from "react";
import { Link } from "react-router-dom";
import abImg1 from "../../images/about.png";
import Shape1 from "../../images/about-bg-shape.svg";
import styles from "./About.module.css";

const About = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className="helpass-about-section section-padding">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-12">
            <div className="about-left-content">
              <div className="about-bg-shape">
                <img src={Shape1} alt="" />
              </div>
              <img src={abImg1} alt="" className={`${styles.serviceCardWrapper}`}/>
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className="about-right-content">
              <div className="wpo-section-title">
                <span>- Câu Chuyện caobangceritage -</span>
                <h2>
                Nơi hội tụ <span>tinh hoa</span> văn hóa vải Cao Bằng 
                </h2>
                <p>
                    Chúng tôi tự hào mang đến cho bạn một bộ sưu tập độc đáo, nơi
                    mỗi mẫu vải không chỉ là một sản phẩm, mà còn là một tác phẩm
                    nghệ thuật, một câu chuyện văn hóa và một phần của di sản
                    dân tộc.
                </p>
              </div>
              {/* <Link onClick={ClickHandler} to="/about" className="theme-btn">
                Donate Now
              </Link> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
